import { Injectable, inject, InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

// WHY: Token enables future switch to runtime-fetched configuration without touching consumers.
export interface EnvironmentConfig {
  production: boolean;
  name: string;
  apiUrl: string;
  frontendUrl: string;
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('ENV_CONFIG', {
  providedIn: 'root',
  factory: () => environment
});

/**
 * Service to provide environment configuration throughout the app
 * Centralizes environment-specific settings like API URLs
 */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private cfg = inject(ENV_CONFIG);

  // Expose only readonly projections; WHY: avoid mutation and keep surface tiny.
  get production() { return this.cfg.production; }
  get name() { return this.cfg.name; }
  get apiUrl() { return this.cfg.apiUrl; }
  get frontendUrl() { return this.cfg.frontendUrl; }

  /** WHY: Central join to ensure no duplicate slashes & future auth headers injection spot */
  getApiEndpoint(endpoint: string): string {
    const base = this.apiUrl.replace(/\/+$/,'');
    const path = ('/' + endpoint).replace(/\/+/, '/');
    return base + path;
  }

  isDocker(): boolean { return this.name === 'docker' || this.name === 'docker-compose'; }
  isLocal(): boolean { return this.name === 'development'; }
}
